import * as React from 'react';

import type { Button as Props } from './button.types';

import VisuallyButton from '../visually-button';

const ButtonRef = React.forwardRef<HTMLButtonElement, Props>(
  ({ type = 'button', ...rest }, ref) => (
    <VisuallyButton elementName="button" ref={ref} type={type} {...rest} />
  ),
);

ButtonRef.displayName = 'Button';

const Button: typeof ButtonRef & {
  sizes: typeof VisuallyButton.sizes;
  variants: typeof VisuallyButton.variants;
} = Object.assign(ButtonRef, {
  sizes: VisuallyButton.sizes,
  variants: VisuallyButton.variants,
});

export default Button;
